import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Page, Reveal, SectionTag } from "@/components/Reveal";
import { PROCESS_STEPS } from "@/lib/data";

export default function Process() {
  return (
    <Page>
      <section className="blueprint-grid relative overflow-hidden">
        <div className="hero-glow pointer-events-none absolute inset-0" />
        <div className="relative mx-auto max-w-7xl px-4 pb-20 pt-36 sm:px-6 lg:px-8 lg:pt-44">
          <Reveal>
            <SectionTag>Process</SectionTag>
            <h1
              data-testid="process-headline"
              className="max-w-4xl font-display text-4xl font-extrabold leading-[1.08] tracking-tight text-slate-50 sm:text-5xl lg:text-6xl"
            >
              From request to drawings in about two weeks
            </h1>
            <p className="mt-7 max-w-2xl text-base leading-relaxed text-slate-400 sm:text-lg">
              Our process is straightforward, so you always know what happens next and when
              your files will arrive.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="mx-auto max-w-5xl px-4 py-24 sm:px-6 lg:px-8 lg:py-32">
        <ol className="relative ml-4 border-l border-cad/25">
          {PROCESS_STEPS.map((s, i) => (
            <li key={s.n} className="relative pb-16 pl-12 last:pb-0">
              <Reveal delay={i * 0.08}>
                <span className="absolute -left-[9px] top-1 h-4 w-4 rounded-full border-2 border-cad bg-canvas" />
                <p className="font-mono text-xs tracking-[0.35em] text-laser">STEP {s.n}</p>
                <h2
                  data-testid={`process-step-${s.n}`}
                  className="mt-3 font-display text-xl font-semibold text-slate-100 sm:text-2xl"
                >
                  {s.title}
                </h2>
                <p className="mt-3 max-w-xl text-sm leading-relaxed text-slate-400 sm:text-base">
                  {s.body}
                </p>
              </Reveal>
            </li>
          ))}
        </ol>

        <Reveal delay={0.15}>
          <div
            data-testid="process-deadline-callout"
            className="blueprint-grid mt-20 rounded-md border border-laser/30 bg-surface p-8 sm:p-10"
          >
            <p className="font-mono text-xs uppercase tracking-[0.3em] text-laser">Tight deadline?</p>
            <p className="mt-4 max-w-2xl font-display text-xl font-semibold leading-snug text-slate-100 sm:text-2xl">
              Tell us when you request a quote, and we'll let you know what's possible.
            </p>
            <Link
              to="/quote"
              data-testid="process-quote-button"
              className="group mt-8 inline-flex items-center gap-2 rounded-sm bg-laser px-8 py-4 font-mono text-xs font-bold uppercase tracking-[0.15em] text-canvas shadow-[0_0_32px_rgba(245,158,11,0.3)] transition-colors duration-200 hover:bg-amber-400"
            >
              Request a Quote
              <ArrowUpRight size={15} className="transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </Link>
          </div>
        </Reveal>
      </section>
    </Page>
  );
}
